export default __webpack_public_path__ + "static/media/signal-bar-white.c1213de9.svg";